"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acilDurumListeSuzgeciSchema = exports.acilDurumListesiSchema = exports.acilDurumIsyeriSatiriSchema = exports.acilDurumOzetiSchema = exports.acilDurumYetkileriSchema = exports.belgeTipiDurumuSchema = exports.tatbikatOzetiSchema = exports.acilIletisimSchema = exports.acilDurumEkipSchema = exports.acilDurumEkipUyesiSchema = exports.kontrolluBelgeSchema = exports.kontrolluBelgeHamSchema = exports.toplanmaNoktasiSchema = exports.acilIletisimGuncelleSchema = exports.acilIletisimOlusturSchema = exports.ACIL_ILETISIM_TELEFON_MAX = exports.ACIL_ILETISIM_GOREV_MAX = exports.kontrolluBelgeOlusturSchema = exports.KONTROLLU_BELGE_ACIKLAMA_MAX = exports.VADE_DURUM_ETIKETI = exports.vadeDurumuSchema = exports.VADE_DURUMLARI = exports.ACIL_DURUM_EKIPMAN_TIPI_REFLERI = exports.ACIL_DURUM_EKIP_REFLERI = exports.kontrolluBelgeTipiSchema = exports.acilDurumBelgeTipiSchema = exports.KONTROLLU_BELGE_TIP_ETIKETI = exports.KONTROLLU_BELGE_TIPLERI = exports.ACIL_DURUM_BELGE_TIP_ETIKETI = exports.ACIL_DURUM_BELGE_TIPLERI = exports.TATBIKAT_TURU_COKLU_ETIKETI = exports.TATBIKAT_TURU_ETIKETI = exports.tatbikatTuruSchema = exports.TATBIKAT_TURLERI = exports.TEHLIKE_SINIFI_ETIKETI = void 0;
exports.tatbikatTurleriniSirala = tatbikatTurleriniSirala;
exports.acilDurumEkibiMi = acilDurumEkibiMi;
exports.readAcilDurumEkipmaniMi = readAcilDurumEkipmaniMi;
exports.yenilemeVadesi = yenilemeVadesi;
exports.vadeDurumu = vadeDurumu;
const zod_1 = require("zod");
const gorevlendirme_1 = require("./gorevlendirme");
const kapi_durumu_1 = require("./kapi-durumu");
const kontrollu_belge_1 = require("./kontrollu-belge");
const vade_1 = require("./vade");
/**
 * ACİL DURUM — KURAL VE SÖZLEŞME KATMANI (Kapsam §29; ERD §10i —
 * 06.09.2026; sertleştirme programı sonrası ÜÇÜNCÜ yapım turu).
 *
 * ════════════════════════════════════════════════════════════════════════
 * TURUN TEK CÜMLESİ: ACİL DURUM MODÜLÜ HİÇBİR ŞEYİ İKİNCİ KEZ TUTMAZ
 * ════════════════════════════════════════════════════════════════════════
 *
 * Ekipler GÖREVLENDİRMEDİR (E2 — ikinci üye kaydı yok), ekipmanlar İŞ
 * EKİPMANI ENVANTERİDİR (E3 — ikinci envanter yok), tatbikat SAHA TURU
 * KABIDIR (E5 — ikinci gözlem/bulgu/tutanak mekanizması yok), toplanma
 * noktası LOKASYON AĞACININ İŞARETİDİR (E4 — yeni kavram yok). Modülün tek
 * yeni nesnesi **kontrollü belge**dir (E1) ve o da GENEL kurulur — doküman
 * modülünün çekirdeği; acil durum belgeleri onun ilk tipidir.
 *
 * ⚠️ Vadeler TÜRETİLİR ve tek yüklemden okunur (`yenilemeVadesi`): belge
 * yenileme vadesi = yürürlük + yükümlülük #17'nin periyodu; tatbikat vadesi
 * = son tatbikat + yükümlülük #18'in periyodu. Periyot **kütüphaneden
 * okunur, uydurulmaz** (Yönerge §5) — bu dosyada tek bir ay sayısı yoktur.
 */
/** `index.ts`teki şemanın yerel ikizi — döngüsel import açmamak için (tip `HazardClass` kilitler). */
const hazardClassSchema = zod_1.z.enum([
    'low_risk',
    'hazardous',
    'highly_hazardous',
]);
/** Tehlike sınıfı etiketi — çıktı (PDF) ve ekran aynı haritayı okur (D2). */
exports.TEHLIKE_SINIFI_ETIKETI = {
    low_risk: 'Az tehlikeli',
    hazardous: 'Tehlikeli',
    highly_hazardous: 'Çok tehlikeli',
};
// ── Tatbikat türü (E5) — İngilizce token yok: saha kavramı, Türkçe ASCII ──
exports.TATBIKAT_TURLERI = ['yangin', 'tahliye', 'deprem', 'diger'];
exports.tatbikatTuruSchema = zod_1.z.enum(exports.TATBIKAT_TURLERI);
exports.TATBIKAT_TURU_ETIKETI = {
    yangin: 'Yangın',
    tahliye: 'Tahliye',
    deprem: 'Deprem',
    diger: 'Diğer',
};
/**
 * G4.1 (07.09.2026) — tür ÇOKLU seçimdir (yangın + tahliye aynı tatbikatta).
 * Olay sınıfı emsali: tür toplamı ≠ tatbikat sayısı; şerh ekran etiketinde ve
 * çıktıda AYNI metinle taşınır (tek kaynak). Raporlar tatbikat sayısını
 * kayıt sayısından okur, tür sayımından değil.
 */
exports.TATBIKAT_TURU_COKLU_ETIKETI = 'Tatbikat türü (ÇOKLU — tür toplamı ≠ tatbikat sayısı)';
/** Sıralı, tekrarsız tür kümesi (girdi sırası değil, sabit sözlük sırası). */
function tatbikatTurleriniSirala(turler) {
    const kume = new Set(turler);
    return exports.TATBIKAT_TURLERI.filter((t) => kume.has(t));
}
// ── Kontrollü belge tipi (E1) — GENEL kavram, acil durum İLK tipi ─────────
/**
 * ✏️ DOKÜMAN TURU (07.09.2026 — Kapsam §31): tip KİMLİKLERİ `kontrollu-belge.ts`e
 * taşındı — çekirdeğin ikinci müşterisi (doküman rafı) geldi ve liste
 * İKİYE ayrıldı: `ACIL_DURUM_BELGE_TIPLERI` (bu modülün iki tipi) ve
 * `DOKUMAN_RAF_TIPLERI` (altı raf tipi). Acil durum yükleme şeması ve
 * Select'i YALNIZ kendi listesini okur — raf tipi bu uçtan yüklenemez.
 * Tip → kalem/yapı haritası `@isg/db controlled-document-rules.ts`te.
 */
var kontrollu_belge_2 = require("./kontrollu-belge");
Object.defineProperty(exports, "ACIL_DURUM_BELGE_TIPLERI", { enumerable: true, get: function () { return kontrollu_belge_2.ACIL_DURUM_BELGE_TIPLERI; } });
Object.defineProperty(exports, "ACIL_DURUM_BELGE_TIP_ETIKETI", { enumerable: true, get: function () { return kontrollu_belge_2.ACIL_DURUM_BELGE_TIP_ETIKETI; } });
Object.defineProperty(exports, "KONTROLLU_BELGE_TIPLERI", { enumerable: true, get: function () { return kontrollu_belge_2.KONTROLLU_BELGE_TIPLERI; } });
Object.defineProperty(exports, "KONTROLLU_BELGE_TIP_ETIKETI", { enumerable: true, get: function () { return kontrollu_belge_2.KONTROLLU_BELGE_TIP_ETIKETI; } });
Object.defineProperty(exports, "acilDurumBelgeTipiSchema", { enumerable: true, get: function () { return kontrollu_belge_2.acilDurumBelgeTipiSchema; } });
Object.defineProperty(exports, "kontrolluBelgeTipiSchema", { enumerable: true, get: function () { return kontrollu_belge_2.kontrolluBelgeTipiSchema; } });
// ── Ekipler (E2) — görevlendirme türlerinin ALTISI, sabit sırayla ──────────
/**
 * Acil durum ekipleri = görevlendirme kütüphanesinin altı kalemi. Sıra
 * ekranın ve PDF'in sırasıdır (yönetmelik sırası: söndürme · kurtarma ·
 * koruma, sonra üç ek ekip). ⚠️ Ada göre eşleşme YAZILMAZ — ref'e bakılır.
 */
exports.ACIL_DURUM_EKIP_REFLERI = [
    gorevlendirme_1.GOREVLENDIRME_SONDURME_REF,
    gorevlendirme_1.GOREVLENDIRME_KURTARMA_REF,
    gorevlendirme_1.GOREVLENDIRME_KORUMA_REF,
    gorevlendirme_1.GOREVLENDIRME_KOORDINATOR_REF,
    gorevlendirme_1.GOREVLENDIRME_CEVRE_REF,
    gorevlendirme_1.GOREVLENDIRME_TRAFIK_REF,
];
function acilDurumEkibiMi(tur) {
    return tur.kutuphaneRef !== null && exports.ACIL_DURUM_EKIP_REFLERI.includes(tur.kutuphaneRef);
}
// ── Acil durum ekipmanı (E3) — TİPİN işareti, ikinci envanter yok ─────────
/**
 * Ekipman tipi kütüphanesinde *"acil durum ekipmanı"* işareti taşıyan altı
 * kalem (yangın algılama · acil aydınlatma · yangın tesisatı · otomatik
 * söndürme · yangın söndürücü · gaz dedektörü). İşaret nüshaya
 * `kurallar.acil_durum_ekipmani = true` olarak iner; müşteri kendi tipini
 * de işaretleyebilir (kural düzenleme serbest — §19/7). Envanter listesinin
 * `acilDurum` süzgeci bu anahtarı okur — ikinci bir liste YOKTUR.
 */
exports.ACIL_DURUM_EKIPMAN_TIPI_REFLERI = [
    'e1000000-0000-4000-8000-000000000024', // Yangın algılama ve önleme sistemi
    'e1000000-0000-4000-8000-000000000025', // Aydınlatma / acil aydınlatma
    'e1000000-0000-4000-8000-000000000030', // Yangın tesisatı (hortum / motopomp / hidrant)
    'e1000000-0000-4000-8000-000000000031', // Otomatik söndürme sistemi (sprinkler + gazlı)
    'e1000000-0000-4000-8000-000000000033', // Yangın söndürücü
    'e1000000-0000-4000-8000-000000000038', // Gaz dedektörü (kalibrasyon)
];
/** Tip kuralının işareti — bozuk/eksik değer `false` (readUyariEsigiGun deseni). */
function readAcilDurumEkipmaniMi(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return false;
    return kurallar['acil_durum_ekipmani'] === true;
}
// ── Vade — TEK YÜKLEM (E1 · E5; C) ─────────────────────────────────────────
/** `YYYY-AA-GG` + n ay (UTC gün ekseni — G11; kurul `ayEkle` ile aynı aritmetik). */
function ayEkle(gun, ay) {
    const d = new Date(`${gun}T00:00:00Z`);
    d.setUTCMonth(d.getUTCMonth() + ay);
    return d.toISOString().slice(0, 10);
}
/**
 * **YENİLEME VADESİ = SON TARİH + PERİYOT.** Belge için son tarih yürürlük
 * tarihi, tatbikat için son yapılmış tatbikatın günüdür; periyot ilgili
 * yükümlülük kaleminin nüshasından çözülür (#17 tehlike sınıfına göre, #18
 * sabit). ⚠️ İkisi de `null` olabilir ve ikisi de **"bilinmiyor"**
 * demektir — sıfır ya da "tam" değil (boş ≠ sıfır dersi): kayıt yoksa vade
 * yoktur, periyot kuralı yoksa vade yoktur.
 */
function yenilemeVadesi(sonTarih, periyotAy) {
    if (sonTarih === null || periyotAy === null || periyotAy <= 0)
        return null;
    return ayEkle(sonTarih, periyotAy);
}
exports.VADE_DURUMLARI = ['yok', 'gecikmis', 'yaklasiyor', 'gecerli'];
exports.vadeDurumuSchema = zod_1.z.enum(exports.VADE_DURUMLARI);
exports.VADE_DURUM_ETIKETI = {
    yok: 'Kayıt yok',
    gecikmis: 'Gecikmiş',
    yaklasiyor: 'Yaklaşıyor',
    gecerli: 'Geçerli',
};
/**
 * Vadenin bugüne göre durumu. `esikGun` bildirim eşiğiyle AYNI sayıdan gelir
 * (`resolveUyariEsigi` — çağıran verir; burada sabit YAZILMAZ ki ekran ile
 * tarama ayrışmasın).
 */
function vadeDurumu(vade, bugun, esikGun) {
    if (vade === null)
        return 'yok';
    // Madde 296 — "gecikmiş mi" TEK YÜKLEMDEN (vade günü son gündür).
    if ((0, vade_1.vadeGectiMi)(vade, bugun))
        return 'gecikmis';
    const esik = ayEkleGun(bugun, esikGun);
    return vade <= esik ? 'yaklasiyor' : 'gecerli';
}
function ayEkleGun(gun, gunSayisi) {
    const d = new Date(`${gun}T00:00:00Z`);
    d.setUTCDate(d.getUTCDate() + gunSayisi);
    return d.toISOString().slice(0, 10);
}
// ── İstek şemaları ────────────────────────────────────────────────────────
exports.KONTROLLU_BELGE_ACIKLAMA_MAX = 500;
/** Multipart alanları düz metin gelir — tarih ISO gün, açıklama isteğe bağlı. */
exports.kontrolluBelgeOlusturSchema = zod_1.z.object({
    // ✏️ Doküman turu: YALNIZ acil durum tipleri — raf tipi bu uçtan yüklenemez (§31/K2).
    tip: kontrollu_belge_1.acilDurumBelgeTipiSchema,
    yururlukTarihi: zod_1.z.iso.date(),
    aciklama: zod_1.z.string().trim().max(exports.KONTROLLU_BELGE_ACIKLAMA_MAX).optional(),
});
exports.ACIL_ILETISIM_GOREV_MAX = 120;
exports.ACIL_ILETISIM_TELEFON_MAX = 40;
/**
 * Acil iletişim satırı (E6). `personId` doluysa AD kişiden gelir (ikinci
 * ad kaynağı yok); boşsa dış numara (itfaiye · hastane) için `ad` zorunlu.
 */
exports.acilIletisimOlusturSchema = zod_1.z
    .object({
    ad: zod_1.z.string().trim().min(1).max(120).nullable().optional(),
    gorev: zod_1.z.string().trim().min(1).max(exports.ACIL_ILETISIM_GOREV_MAX),
    telefon: zod_1.z.string().trim().min(1).max(exports.ACIL_ILETISIM_TELEFON_MAX),
    personId: zod_1.z.uuid().nullable().optional(),
})
    .superRefine((g, ctx) => {
    if (!g.personId && !(g.ad ?? '').trim()) {
        ctx.addIssue({
            code: 'custom',
            path: ['ad'],
            message: 'Kişi seçilmediyse ad girin',
        });
    }
});
exports.acilIletisimGuncelleSchema = zod_1.z
    .object({
    gorev: zod_1.z.string().trim().min(1).max(exports.ACIL_ILETISIM_GOREV_MAX).optional(),
    telefon: zod_1.z.string().trim().min(1).max(exports.ACIL_ILETISIM_TELEFON_MAX).optional(),
    sira: zod_1.z.number().int().min(0).optional(),
})
    .refine((v) => Object.keys(v).length > 0, 'Güncellenecek alan yok');
/** Toplanma noktası işareti (E4) — lokasyon düğümünün tek boolean'ı. */
exports.toplanmaNoktasiSchema = zod_1.z.object({ toplanmaNoktasi: zod_1.z.boolean() });
// ── Yanıt şemaları ────────────────────────────────────────────────────────
exports.kontrolluBelgeHamSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    tip: kontrollu_belge_1.kontrolluBelgeTipiSchema,
    tipEtiketi: zod_1.z.string().min(1),
    dosyaAdi: zod_1.z.string().min(1),
    mimeType: zod_1.z.string().min(1),
    boyutBytes: zod_1.z.number().int().positive(),
    yururlukTarihi: zod_1.z.iso.date(),
    /** TÜRETİLİR — yürürlük + tipin periyodu (kolon yok). */
    yenilemeVadesi: zod_1.z.iso.date().nullable(),
    periyotAy: zod_1.z.number().int().positive().nullable(),
    vadeDurumu: exports.vadeDurumuSchema,
    /** Yasal yükümlülük bağı — nüshanın ADI (tip kuralından türetilir). */
    yukumlulukKalemAd: zod_1.z.string().nullable(),
    aciklama: zod_1.z.string().nullable(),
    yukleyenEtiket: zod_1.z.string().min(1),
    /** Aynı tipin en son yürürlüktekisi mi (eski sürümler tarihçe olarak durur). */
    guncel: zod_1.z.boolean(),
    createdAt: zod_1.z.iso.datetime(),
});
/**
 * P13-c (madde 227) — belge SİLME kapısı SATIR BAŞINA: acil durum yazma
 * adımları (şapka → işyeri bahçesi → arşiv) → sahiplik (yükleyen VEYA holding
 * yön.). Kapalı hâl yok. ~~`silinebilirBelgeIdleri`~~ söküldü.
 */
exports.kontrolluBelgeSchema = exports.kontrolluBelgeHamSchema.extend({
    silmeKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.acilDurumEkipUyesiSchema = zod_1.z.object({
    designationId: zod_1.z.uuid(),
    personId: zod_1.z.uuid(),
    adSoyad: zod_1.z.string().min(1),
    baslangicTarihi: zod_1.z.iso.date(),
    /** Görevlendirme motorunun türetmesi (G5) — burada yalnız gösterilir. */
    eksik: zod_1.z.boolean(),
    eksikSartlar: zod_1.z.array(gorevlendirme_1.uygunlukSatiriSchema),
});
/**
 * Ekip satırı — TÜRETİLMİŞ GÖRÜNÜM (E2). `gereken` null = zorunlu sayı
 * kuralı **tanımsız** (bölen boş — madde 175); ekran o satırda sıfır ya da
 * "tam" yazmaz, *"Tanımsız"* yazar. Sayılar görevlendirme motorunun
 * `readIsyeriZorunluGorevlendirmeler` yükleminden gelir; ikinci sayaç yok.
 */
exports.acilDurumEkipSchema = zod_1.z.object({
    gorevlendirmeTuruId: zod_1.z.uuid(),
    gorevlendirmeTuruAd: zod_1.z.string().min(1),
    kutuphaneRef: zod_1.z.uuid(),
    gereken: zod_1.z.number().int().min(0).nullable(),
    mevcut: zod_1.z.number().int().min(0).nullable(),
    yeterli: zod_1.z.number().int().min(0).nullable(),
    eksik: zod_1.z.number().int().min(0).nullable(),
    uyeler: zod_1.z.array(exports.acilDurumEkipUyesiSchema),
});
exports.acilIletisimSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    sira: zod_1.z.number().int().min(0),
    ad: zod_1.z.string().min(1),
    gorev: zod_1.z.string().min(1),
    telefon: zod_1.z.string().min(1),
    personId: zod_1.z.uuid().nullable(),
});
exports.tatbikatOzetiSchema = zod_1.z.object({
    sonTarih: zod_1.z.iso.date().nullable(),
    sonTakipNo: zod_1.z.string().nullable(),
    sonSiteTourId: zod_1.z.uuid().nullable(),
    /** TÜRETİLİR — son tatbikat + #18 periyodu; ikisinden biri yoksa null. */
    sonrakiVade: zod_1.z.iso.date().nullable(),
    periyotAy: zod_1.z.number().int().positive().nullable(),
    vadeDurumu: exports.vadeDurumuSchema,
    acikTatbikatSayisi: zod_1.z.number().int().min(0),
});
exports.belgeTipiDurumuSchema = zod_1.z.object({
    tip: kontrollu_belge_1.kontrolluBelgeTipiSchema,
    tipEtiketi: zod_1.z.string().min(1),
    guncelBelge: exports.kontrolluBelgeSchema.nullable(),
});
exports.acilDurumYetkileriSchema = zod_1.z.object({
    /** Şapka ∧ bahçe ∧ arşiv — belge · iletişim (`yazmaKapisi.yazabilir`). */
    yazabilir: zod_1.z.boolean(),
    /** P13 — acil durum yazma kapısı (şapka → işyeri bahçesi → arşiv) + sebep. */
    yazmaKapisi: kapi_durumu_1.kapiDurumuSchema,
    /**
     * P13 · B1/4 — *"Tatbikat aç"* = SAHA TURU AÇMA kapısı (saha sorumlusu dahil).
     * ✏️ Eski yorum *"belge · iletişim · tatbikat açma"* diyordu ve yanlıştı:
     * tatbikat bu listenin değil saha turu listesinin kapısıdır.
     */
    tatbikatKapisi: kapi_durumu_1.kapiDurumuSchema,
});
exports.acilDurumOzetiSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    tehlikeSinifi: hazardClassSchema,
    calisanSayisi: zod_1.z.number().int().min(0),
    /** Tip başına GÜNCEL belge (yoksa null) — E1. */
    belgeTipleri: zod_1.z.array(exports.belgeTipiDurumuSchema),
    /** Tüm belgeler, yeni → eski (tarihçe). */
    belgeler: zod_1.z.array(exports.kontrolluBelgeSchema),
    ekipler: zod_1.z.array(exports.acilDurumEkipSchema),
    toplanmaNoktalari: zod_1.z.array(zod_1.z.object({ id: zod_1.z.uuid(), ad: zod_1.z.string().min(1) })),
    tatbikat: exports.tatbikatOzetiSchema,
    iletisim: zod_1.z.array(exports.acilIletisimSchema),
    /** İşyerindeki AKTİF acil durum ekipmanı sayısı — envanter süzgecinin okuduğu aynı işaret. */
    acilDurumEkipmanSayisi: zod_1.z.number().int().min(0),
    yetkiler: exports.acilDurumYetkileriSchema,
});
exports.acilDurumIsyeriSatiriSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid(),
    workplaceAd: zod_1.z.string().min(1),
    companyAd: zod_1.z.string().min(1),
    tehlikeSinifi: hazardClassSchema,
    planVadesi: zod_1.z.iso.date().nullable(),
    planVadeDurumu: exports.vadeDurumuSchema,
    krokiVar: zod_1.z.boolean(),
    /** Zorunlu sayısı tanımlı ekiplerde toplam eksik; hiçbir ekipte kural yoksa null. */
    ekipEksik: zod_1.z.number().int().min(0).nullable(),
    tatbikatVadesi: zod_1.z.iso.date().nullable(),
    tatbikatVadeDurumu: exports.vadeDurumuSchema,
    toplanmaNoktasiSayisi: zod_1.z.number().int().min(0),
});
exports.acilDurumListesiSchema = zod_1.z.object({
    satirlar: zod_1.z.array(exports.acilDurumIsyeriSatiriSchema),
    toplam: zod_1.z.number().int().nonnegative(),
    sayfa: zod_1.z.number().int().positive(),
    sayfaBoyutu: zod_1.z.number().int().positive(),
});
exports.acilDurumListeSuzgeciSchema = zod_1.z.object({
    workplaceId: zod_1.z.uuid().optional(),
    sayfa: zod_1.z.coerce.number().int().positive().default(1),
    sayfaBoyutu: zod_1.z.coerce.number().int().positive().max(100).default(25),
});
//# sourceMappingURL=acil-durum.js.map